{
  "checkAgainAria": "{{status}}. Erneut prüfen",
  "explanation": {
    "checking": "Die App fragt den DMW-Server, ob er bereit ist.",
    "connected": "Der DMW-Server und seine Datenbank sind bereit.",
    "databaseUnavailable": "Der DMW-Server läuft, erreicht aber seine Datenbank nicht. Bis dahin können keine Daten geladen oder gespeichert werden.",
    "faulty": "Die Antwort passt nicht zu dem, was diese Version der App erwartet. App und Server passen womöglich nicht zusammen.",
    "unreachable": "Der DMW-Server antwortet nicht. Prüfen Sie, ob er läuft und ob dieser Rechner online ist."
  },
  "reload": "Neu laden",
  "status": {
    "checking": "Server wird geprüft",
    "connected": "Server verbunden",
    "databaseUnavailable": "Datenbank nicht erreichbar",
    "faulty": "Server antwortet unerwartet",
    "unreachable": "Server nicht erreichbar"
  }
}
